<div class="grid grid-cols-1 md:grid-cols-2 gap-4" [formGroup]="form">
    <mat-form-field class="w-full md:col-span-2">
        <mat-label>{{ 'label_interest_register_field_trade_date' | translate }}</mat-label>
        <input matInput [matDatepicker]="transactionDatePicker" formControlName="transactionDate" />
        <mat-datepicker-toggle matIconSuffix [for]="transactionDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #transactionDatePicker></mat-datepicker>

        @if (form.get('transactionDate')?.hasError('required') && form.get('transactionDate')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full">
        <mat-label>{{ 'label_interest_register_field_buyer' | translate }}</mat-label>
        <mat-select formControlName="buyer">
            @for (buyer of buyerAndSellerTypes; track buyer) {
                <mat-option [value]="buyer"> {{ buyer }}</mat-option>
            }
        </mat-select>

        @if (form.get('buyer')?.hasError('required') && form.get('buyer')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full">
        <mat-label>{{ 'label_interest_register_field_seller' | translate }}</mat-label>
        <mat-select formControlName="seller">
            @for (seller of buyerAndSellerTypes; track seller) {
                <mat-option [value]="seller"> {{ seller }}</mat-option>
            }
        </mat-select>

        @if (form.get('buyer')?.hasError('required') && form.get('buyer')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full md:col-span-2">
        <mat-label>{{ 'label_interest_register_field_instrument_name' | translate }}</mat-label>
        <input matInput formControlName="financialInstrumentName" />

        @if (form.get('financialInstrumentName')?.hasError('required') && form.get('financialInstrumentName')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full">
        <mat-label>{{ 'label_interest_register_field_nominal_value' | translate }}</mat-label>
        <input matInput numericFormat maxlength="11" inputmode="decimal" formControlName="nominalValue" />

        @if (form.get('nominalValue')?.hasError('required') && form.get('nominalValue')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full">
        <mat-label>{{ 'label_interest_register_field_yield_or_price' | translate }}</mat-label>
        <input matInput numericFormat maxlength="11" inputmode="decimal" formControlName="yieldOrPrice" />

        @if (form.get('yieldOrPrice')?.hasError('required') && form.get('yieldOrPrice')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full md:col-span-2">
        <mat-label>{{ 'label_interest_register_field_transaction_terms_reference' | translate }}</mat-label>
        <textarea matInput rows="6" formControlName="transactionTermsReference"></textarea>

        @if (form.get('transactionTermsReference')?.hasError('required') && form.get('transactionTermsReference')?.touched) {
            <mat-error>{{ 'label_field_required' | translate }}</mat-error>
        }
    </mat-form-field>

    <mat-form-field class="w-full md:col-span-2">
        <mat-label>{{ 'label_interest_register_field_interest_assessment' | translate }}</mat-label>
        <textarea matInput rows="6" formControlName="interestAssessment"></textarea>
    </mat-form-field>
</div>
